import * as React from "react";
import "../../gatsby-browser.js";
import Navbar from "../component/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { motion } from "framer-motion";
import MetaTags from "../component/MetaTags.jsx";
import resourcesData from "../data/resources.json";

class Resources extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      resources: resourcesData,
    };
  }

  handleDownload = (url, title) => {
    // Create a temporary anchor element to trigger download
    const link = document.createElement("a");
    link.href = url;
    link.download = title;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const pageVariants = {
      initial: {
        opacity: 0,
      },
      in: {
        opacity: 1,
      },
      out: {
        opacity: 0,
      },
    };

    const { resources } = this.state;

    return (
      <>
        <Navbar />
        <motion.div
          initial="initial"
          animate="in"
          exit="out"
          variants={pageVariants}
        >
          <section 
            id="resources-sec" 
            className="course-banner"
            style={{
              height: "auto",
              paddingTop: "6rem",
              paddingBottom: "2rem",
              marginBottom: "1.5rem",
              minHeight: "auto",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <div 
              className="language-content"
              style={{
                margin: "0 auto",
                flex: "none",
                maxWidth: "1200px",
                width: "100%"
              }}
            >
              <h1 align="center">Downloadable Resources</h1>
              <p align="center">
                Access free study materials, question papers, and guides for
                French, Japanese, German, and Coding courses.
              </p>
            </div>
          </section>

          <div className="container" style={{ marginTop: "2rem", marginBottom: "4rem" }}>
            {/* French Resources Section */}
            <div className="row about-extra mb-5">
              <div align="center" className="mb-4">
                <h2 className="light-text">
                  FRENCH{" "}
                  <span className="highlighted-text">RESOURCES</span>
                </h2>
              </div>
              <div className="row">
                {resources.french.map((resource) => (
                  <div
                    key={resource.id}
                    className="col-lg-6 col-md-6 col-sm-12 mb-4 wow bounceInUp"
                  >
                    <div className="box" style={{ padding: "2rem", height: "100%" }}>
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div style={{ flex: 1 }}>
                          <h4 style={{ color: "#283d50", marginBottom: "0.5rem", fontWeight: "600" }}>
                            {resource.title}
                          </h4>
                          <p style={{ color: "#556877", marginBottom: "1rem" }}>
                            {resource.description}
                          </p>
                        </div>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#007bff",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "4px",
                            marginLeft: "1rem",
                          }}
                        >
                          {resource.fileType}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span style={{ color: "#556877", fontSize: "0.9rem" }}>
                          Size: {resource.fileSize}
                        </span>
                        <a
                          href={resource.downloadUrl}
                          download
                          className="btn btn-primary"
                          style={{
                            padding: "0.5rem 1.5rem",
                            textDecoration: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleDownload(
                              resource.downloadUrl,
                              resource.title
                            );
                          }}
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>{" "}
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Japanese Resources Section */}
            <div className="row about-extra mb-5">
              <div align="center" className="mb-4">
                <h2 className="light-text">
                  JAPANESE{" "}
                  <span className="highlighted-text">RESOURCES</span>
                </h2>
              </div>
              <div className="row">
                {resources.japanese.map((resource) => (
                  <div
                    key={resource.id}
                    className="col-lg-6 col-md-6 col-sm-12 mb-4 wow bounceInUp"
                  >
                    <div className="box" style={{ padding: "2rem", height: "100%" }}>
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div style={{ flex: 1 }}>
                          <h4 style={{ color: "#283d50", marginBottom: "0.5rem", fontWeight: "600" }}>
                            {resource.title}
                          </h4>
                          <p style={{ color: "#556877", marginBottom: "1rem" }}>
                            {resource.description}
                          </p>
                        </div>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#007bff",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "4px",
                            marginLeft: "1rem",
                          }}
                        >
                          {resource.fileType}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span style={{ color: "#556877", fontSize: "0.9rem" }}>
                          Size: {resource.fileSize}
                        </span>
                        <a
                          href={resource.downloadUrl}
                          download
                          className="btn btn-primary"
                          style={{
                            padding: "0.5rem 1.5rem",
                            textDecoration: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleDownload(
                              resource.downloadUrl,
                              resource.title
                            );
                          }}
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>{" "}
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* German Resources Section */}
            <div className="row about-extra mb-5">
              <div align="center" className="mb-4">
                <h2 className="light-text">
                  GERMAN{" "}
                  <span className="highlighted-text">RESOURCES</span>
                </h2>
              </div>
              <div className="row">
                {resources.german.map((resource) => (
                  <div
                    key={resource.id}
                    className="col-lg-6 col-md-6 col-sm-12 mb-4 wow bounceInUp"
                  >
                    <div className="box" style={{ padding: "2rem", height: "100%" }}>
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div style={{ flex: 1 }}>
                          <h4 style={{ color: "#283d50", marginBottom: "0.5rem", fontWeight: "600" }}>
                            {resource.title}
                          </h4>
                          <p style={{ color: "#556877", marginBottom: "1rem" }}>
                            {resource.description}
                          </p>
                        </div>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#007bff",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "4px",
                            marginLeft: "1rem",
                          }}
                        >
                          {resource.fileType}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span style={{ color: "#556877", fontSize: "0.9rem" }}>
                          Size: {resource.fileSize}
                        </span>
                        <a
                          href={resource.downloadUrl}
                          download
                          className="btn btn-primary"
                          style={{
                            padding: "0.5rem 1.5rem",
                            textDecoration: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleDownload(
                              resource.downloadUrl,
                              resource.title
                            );
                          }}
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>{" "}
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Coding Resources Section */}
            <div className="row about-extra mb-5">
              <div align="center" className="mb-4">
                <h2 className="light-text">
                  CODING{" "}
                  <span className="highlighted-text">RESOURCES</span>
                </h2>
              </div>
              <div className="row">
                {resources.coding.map((resource) => (
                  <div
                    key={resource.id}
                    className="col-lg-6 col-md-6 col-sm-12 mb-4 wow bounceInUp"
                  >
                    <div className="box" style={{ padding: "2rem", height: "100%" }}>
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div style={{ flex: 1 }}>
                          <h4 style={{ color: "#283d50", marginBottom: "0.5rem", fontWeight: "600" }}>
                            {resource.title}
                          </h4>
                          <p style={{ color: "#556877", marginBottom: "1rem" }}>
                            {resource.description}
                          </p>
                        </div>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#007bff",
                            color: "white",
                            padding: "0.5rem 1rem",
                            borderRadius: "4px",
                            marginLeft: "1rem",
                          }}
                        >
                          {resource.fileType}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span style={{ color: "#556877", fontSize: "0.9rem" }}>
                          Size: {resource.fileSize}
                        </span>
                        <a
                          href={resource.downloadUrl}
                          download
                          className="btn btn-primary"
                          style={{
                            padding: "0.5rem 1.5rem",
                            textDecoration: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleDownload(
                              resource.downloadUrl,
                              resource.title
                            );
                          }}
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>{" "}
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <Footer />
        </motion.div>
        <MetaTags
          title={"Resources | Koderbox"}
          description="Download free study materials, question papers, and guides for French, Japanese, German, and Coding courses from Koderbox."
          path="/resources/"
        />
      </>
    );
  }
}

export default Resources;

